module.exports = __webpack_public_path__ + "img/x_button.b7261369.svg";